export default {
    name: 'click-outside2',
    mounted(el, binding) {
        el.clickOutside = function (event) {
            if (!(el === event.target || el.contains(event.target))) {
                binding.value(event);
            }
        };
        document.body.addEventListener('click', el.clickOutside);
    },
    unmounted(el) {
        document.body.removeEventListener('click', el.clickOutside);
    }
};
